import { use, useCallback, useState } from "react";
import { CardNameRef } from "../components/CardFormFields.tsx";
import { EditCardDialog } from "../components/EditCardDialog.tsx";
import { DetailPanelContext } from "../detailPanel/DetailPanelContext.ts";

interface EditableCard {
  id: string;
  projectId: string;
  // Shared cards are edited in their responsible project only
  shared?: boolean;
}

const noCards: CardNameRef[] = [];

export const useCardEditorPanel = ({
  cards = noCards,
  canDelete = true,
}: {
  // The cards the editor checks a changed name against
  cards?: CardNameRef[];
  canDelete?: boolean;
} = {}) => {
  const { openPanel, closePanel } = use(DetailPanelContext);
  const [selectedCardId, setSelectedCardId] = useState<string | null>(null);

  const handleDetailClick = useCallback(
    (card: EditableCard) => {
      if (card.id === selectedCardId) {
        closePanel();
        setSelectedCardId(null);
        return;
      }
      if (card.shared) return;

      openPanel(
        <EditCardDialog
          key={`edit_${card.id}`}
          cardId={card.id}
          projectId={card.projectId}
          onClose={closePanel}
          cards={cards}
          canDelete={canDelete}
        />,
        {
          onClose: () =>
            setSelectedCardId((currentCardId) =>
              currentCardId === card.id ? null : currentCardId,
            ),
        },
      );
      setSelectedCardId(card.id);
    },
    [canDelete, cards, closePanel, openPanel, selectedCardId],
  );

  return { handleDetailClick, selectedCardId };
};
